import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/investigadores',
      name: 'investigadores',
      component: () => import('@/views/Investigadores.vue')
    },
    {
      path: '/organizaciones',
      name: 'organizaciones',
      component: () => import('@/views/Organizaciones.vue')
    },
    {
      path: '/academicas',
      name: 'academicas',
      component: () => import('@/views/Academica.vue')
    },
    {
      path: '/gubernamental',
      name: 'gubernamental',
      component: () => import('@/views/Gubernamental.vue')
    },
    {
      path: '/secti',
      name: 'sectiSystem',
      beforeEnter() {location.href = 'https://acceso-seicti.cocyted.mx'}
    },
    {
      path: '/convocatorias',
      name: 'convocatorias',
      component: () => import('@/views/Convocatorias.vue')
    },
    {
      path: '/proyectos-de-investigacion',
      name: 'Proyectos',
      component: () => import('@/views/Proyectos.vue')
    },
    {
      path: '/productividad',
      name: 'productividad',
      component: () => import('@/views/Productividad.vue')
    },
    {
      path: '/quienes_somos',
      name: 'quienes_somos',
      component: () => import('@/views/QuienesSomos.vue')
    },
    {
      path: '/marco_normativo',
      name: 'marco_normativo',
      component: () => import('@/views/MarcoNormativo.vue')
    },
    {
      path: '/redes_tematicas',
      name: 'redes_tematicas',
      component: () => import('@/views/RedesTematicas.vue')
    },
    {
      path: '/investigador_email',
      name: 'investigador-email',
      component: () => import('@/views/InvestigadorEmail.vue')
    },
    {
      path: '/indicadores',
      name: 'indicadores',
      component: () => import('@/views/Indicadores/DashboardIndicador.vue')
    },
    {
      path: '/',
      name: 'indicador-investigadores-area',
      component: () => import('@/views/Indicadores/IndicadorInvestigadoresArea.vue')
    },
    {
      path: '/',
      name: 'indicador-proyectos-area',
      component: () => import('@/views/Indicadores/IndicadorProyectosArea.vue')
    },
    {
      path: '/',
      name: 'indicador-organizaciones-tipo',
      component: () => import('@/views/Indicadores/IndicadorOrganizacionesTipo.vue')
    },
    {
      path: '/',
      name: 'indicador-investigadores-genero',
      component: () => import('@/views/Indicadores/IndicadorInvestigadoresGenero.vue')
    },
    {
      path: '/',
      name: 'indicador-investigadores-grado',
      component: () => import('@/views/Indicadores/IndicadorInvestigadoresGrado.vue')
    },
    {
      path: '/',
      name: 'indicador-proyectos-apoyados',
      component: () => import('@/views/Indicadores/IndicadorProyectosApoyados.vue')
    },
    {
      path: '/sei',
      name: 'sei',
      component: () => import('@/views/Sei.vue')
    },
    {
      path: '/infraestructura',
      name: 'infraestructura',
      component: () => import('@/views/Infraestructura.vue')
    },
    {
      path: '/capital_humano',
      name: 'capital_humano',
      component: () => import('@/views/CapitalHumano.vue')
    },
    {
      path: '/',
      name: 'investigadores-lineas-modal',
      component: () => import('@/views/InvestigadoresLineasModal.vue')
    },
    {
      path: '/',
      name: 'areas-investigacion',
      component: () => import('@/views/capacidades_cti/Areas_investigacion.vue')
    },
    {
      path: '/certificaciones',
      name: 'certificaciones',
      component: () => import('@/views/capacidades_cti/Certificacion.vue')
    },
    {
      path: '/equipo-especializado',
      name: 'equipo-especializado',
      component: () => import('@/views/capacidades_cti/Equipo_especializado.vue')
    },
    {
      path: '/grupos-investigacion',
      name: 'grupos-investigacion',
      component: () => import('@/views/capacidades_cti/Grupos_investigacion.vue')
    },
    {
      path: '/servicios',
      name: 'servicios',
      component: () => import('@/views/capacidades_cti/Servicios.vue')
    },
  ]
})
